<template>
  <el-dialog :visible.sync="innerVisible" :title="title" width="900px" top="5vh" class="ai-quality-chat-dialog" append-to-body :modal="false" @close="handleClose">
    <div class="chat-info-row">
      <div class="chat-info-block">
        <div class="chat-info-item"><span class="label">客户昵称：</span>{{ customer.external_name }}</div>
        <div class="chat-info-item" v-if="customer.external_remark"><span class="label">客户备注：</span>{{ customer.external_remark }}</div>
        <div class="chat-info-item"><span class="label">绑定账号：</span>{{ customer.bind_account || customer.bind_user_name || '—' }}</div>
      </div>
      <div class="chat-info-block">
        <div class="chat-info-item"><span class="label">企微客服：</span>{{ service.contact_name }}</div>
        <div class="chat-info-item"><span class="label">负责客服：</span>{{ service.responsible_admin_name || '—' }}</div>
        <div class="chat-info-item"><span class="label">地区：</span>{{ service.city_name || '—' }}</div>
      </div>
    </div>
    <div class="chat-title-row">
      <span>聊天记录</span>
      <span class="count">共 {{ messages.length }} 条消息</span>
    </div>
    <div class="chat-message-list" ref="messageList">
      <div
        v-for="message in normalizedMessages"
        :key="message.msgid"
        :id="`ai-quality-msg-${message.msgid}`"
        :class="['chat-message-item', message.sender_type === 'service' ? 'is-service' : 'is-player', { 'is-hit': message.is_hit }]"
      >
        <div class="chat-message-meta">
          <span>{{ message.sender_type === 'service' ? service.contact_name : customer.external_name }}</span>
          <span class="time">{{ message.msgtime }}</span>
        </div>
        <div class="chat-message-bubble">
          <template v-if="message.displayType === 'text'">{{ message.displayContent }}</template>
          <template v-else-if="message.displayType === 'image'">
            <el-image v-for="image in message.displayImages" :key="image" :src="image" :preview-src-list="imagePreviewList" style="max-width: 200px">
              <div slot="error" class="chat-media-placeholder">{{ message.displayTypeLabel }}加载失败</div>
            </el-image>
            <span v-if="!message.displayImages.length" class="chat-media-placeholder">{{ message.displayTypeLabel }}处理中</span>
          </template>
          <template v-else-if="message.displayType === 'mixed'">
            <div class="chat-message-type">{{ message.displayTypeLabel }}</div>
            <div v-if="message.displayContent" class="chat-message-text">{{ message.displayContent }}</div>
            <div v-if="message.displayImages.length" class="chat-message-images">
              <el-image v-for="image in message.displayImages" :key="image" :src="image" :preview-src-list="imagePreviewList" style="max-width: 200px">
                <div slot="error" class="chat-media-placeholder">{{ message.displayTypeLabel }}加载失败</div>
              </el-image>
            </div>
          </template>
          <template v-else>
            <div class="chat-message-type">{{ message.displayTypeLabel }}</div>
            <div v-if="message.displayContent" class="chat-message-text">{{ message.displayContent }}</div>
          </template>
          <div class="chat-message-hit" v-if="message.is_hit">AI命中：{{ (message.hit_labels || []).join('、') }}</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { formatWecomMessage } from '../../messageFormatter';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '聊天记录',
    },
    messages: {
      type: Array,
      default: () => [],
    },
    scrollToMsgid: {
      type: String,
      default: '',
    },
    customer: {
      type: Object,
      default: () => ({}),
    },
    service: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      innerVisible: this.visible,
    };
  },
  computed: {
    normalizedMessages() {
      return (this.messages || []).map((message, index) => {
        const displayMessage = formatWecomMessage(message);
        return {
          ...message,
          msgid: message.msgid || index,
          displayType: displayMessage.displayType,
          displayTypeLabel: displayMessage.typeLabel,
          displayContent: displayMessage.content,
          displayImages: displayMessage.images,
        };
      });
    },
    imagePreviewList() {
      return this.normalizedMessages
        .reduce((list, message) => list.concat(message.displayImages || []), [])
        .filter(Boolean);
    },
  },
  watch: {
    visible(val) {
      this.innerVisible = val;
      if (val) {
        this.$nextTick(this.scrollToTarget);
      }
    },
  },
  methods: {
    scrollToTarget() {
      if (!this.scrollToMsgid) {
        return;
      }
      const el = document.getElementById(`ai-quality-msg-${this.scrollToMsgid}`);
      if (el) {
        el.scrollIntoView({ block: 'center' });
      }
    },
    handleClose() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style scoped>
.chat-info-row {
  display: flex;
  gap: 40px;
  padding-bottom: 16px;
  margin-bottom: 12px;
  border-bottom: 1px solid #e6ebf2;
}
.chat-info-block {
  flex: 1;
}
.chat-info-item {
  line-height: 1.8;
  color: #4f5661;
}
.chat-info-item .label {
  color: #8792a2;
}
.chat-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
  font-weight: 700;
  color: #263447;
}
.chat-title-row .count {
  font-weight: 400;
  color: #8792a2;
  font-size: 12px;
}
.chat-message-list {
  max-height: 55vh;
  overflow-y: auto;
  padding: 10px;
  background: #f6f8fb;
  border-radius: 4px;
}
.chat-message-item {
  margin: 14px 0;
}
.chat-message-item.is-service {
  text-align: right;
}
.chat-message-meta {
  font-size: 12px;
  color: #8792a2;
  margin-bottom: 4px;
}
.chat-message-item.is-service .chat-message-meta .time {
  margin-left: 8px;
}
.chat-message-item.is-player .chat-message-meta .time {
  margin-left: 8px;
}
.chat-message-bubble {
  display: inline-block;
  max-width: 70%;
  text-align: left;
  padding: 10px 14px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #e6ebf2;
  line-height: 1.7;
}
.chat-message-item.is-service .chat-message-bubble {
  background: #e8f4ff;
  border-color: #b8dcff;
}
.chat-message-item.is-hit .chat-message-bubble {
  background: #fff7d6;
  border: 2px solid #f0bd28;
}
.chat-message-hit {
  margin-top: 6px;
  font-size: 12px;
  color: #a67c00;
}
.chat-message-type {
  display: inline-block;
  margin-bottom: 4px;
  padding: 1px 8px;
  border-radius: 10px;
  background: #eef5ff;
  color: #409eff;
  font-size: 12px;
  font-weight: 600;
}
.chat-message-text {
  word-break: break-word;
}
.chat-message-images {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 6px;
}
.chat-media-placeholder {
  color: #8792a2;
  font-size: 12px;
}
</style>
